import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './baseService';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  public getResource(id: string): Observable<any> {
    return this.http.get(`${environment.api_url}/${window['ed47Platform']}/config/${id}`);
  }
}
